import React from 'react';

import { Link } from 'libs/router';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import SystemMessage from './SystemMessage';

type Props = {
  campaignId?: number,
  subcampaignId?: number,
  text?: string,
  isBrand?: boolean
};

class SystemChatMessageBriefUpdated extends SystemMessage<Props> {
  render() {
    const {
      text,
      campaignId,
      subcampaignId,
      isBrand
    } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('brief-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div className="messages-system-message__bubble">
            <div className="messages-system-message__heading">
              {text}
            </div>
            <div className="messages-system-message__paragraph">
              {__t('system_message.brief_updated')}
            </div>
            <div className="messages-system-message__brief">
              <Link
                to={`/campaigns/${campaignId}/${isBrand ? 'subcampaigns' : 'details'}/${subcampaignId}`}
                target="_blank"
                className="messages-system-message__link"
              >
                {__t('system_message.view_the_brief')}
              </Link>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageBriefUpdated;
